import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import "../../_components/antd.css";
import { Table, Tooltip } from "antd";
//import Data from "../../assets/jsons/user";
import {
  onShowSizeChange,
  itemRender,
  showTotal
} from "../../_components/paginationfunction";
import api from "../../api/api"


import { useAuth } from "../../context/AuthContext";
import { useHistory } from "react-router-dom";
import AddUser from "./AddUser";
import DeleteUser from "./DeleteUser";
import UserMobile from "./UserMobile";
import { useTranslation } from "react-i18next";

const Users = () => {
  const {user} = useAuth();
  const history = useHistory();
      useEffect(()=>{
         
       
          if(user.role != "Admin"){
            history.push("/dashboard")
          }
          fetchData()
      },[])

const { t } = useTranslation();
      const [loadingStaff, setloadingStaff] = useState(false);
      const [error, setError] = useState(null);
      
      const [data, setData] = useState([]);
      const [nextPage, setNextPage] = useState(null);
      const [prevPage, setPrevPage] = useState(null);
      const [currentPage, setCurrentPage] = useState(1);
      const [count, setCount] = useState(0);

      const fetchData = async (page = 1) => {
  
    
        setloadingStaff(true)
        setError(null)
    
    
        try {
    
       
          let typeurl;
          if(user.type == "agency")typeurl="/staff-agency/" + `?page=${page}`;
          else if (user.type == "supplier")typeurl="/staff-supplier/" + `?page=${page}`;
          else return
    
          const response = await api.get(typeurl); // No need to wrap `data` in an object
    
         
          console.log("Response Code:", response.status);
    
        
  
  
    
              // if(response.data.length==0)
              // response.data.forEach(item => console.log(item));
          
    
         
    
              setData(response.data.results)
              setNextPage(response.data.next)
              setPrevPage(response.data.previous)
              setCount(response.data.count)
       
    
          
    
        } catch (error) {
          //console.error("Error submitting form:", error);
          console.log( error);
          // Extract response code if available
          const responseCode = error.response.data.detail ? error.response.data.detail : "Unknown";
          
          setError(responseCode)
          console.log("Response Code:", responseCode);
    
    
        } finally {
    
    
          setloadingStaff(false);
        }
      }

  const handlePageChange = (page) => {
    if (page < 1 || page > Math.ceil(count / 10)) return;
    setCurrentPage(page);
    fetchData(page);
  };

  const [menu, setMenu] = useState(false);
  const [selectedUser, setSelectedUser] = useState(false);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  //const datasource = Data?.Data;


  const columns = [
    {
      title: "#",
      //dataIndex: "id",
      render: (text, record, index) => index + 1,
      sorter: false,
    },
    // {
    //   title: "Action",
    //   render: (record) => {
    //     return record.role == 'Staff' && (
    //         <button
    //           className="btn btn-danger"
    //           data-bs-toggle="modal"
    //           data-bs-target="#delete_user"
    //           onClick={() => setSelectedUser(record)}
    //         >
    //          Delete
    //         </button>
    //     )
    //   }
    // },
    {
      title: t("User Name"),
      dataIndex: "name",
      render: (img, record) => (
        <div>
          <h2 className="table-avatar">
            <Link to={`/profile/${record.id}`}>
              {record.name} 
            </Link>
          </h2>
        </div>
      ),
     
    },
    {
      title: t("Email"),
      dataIndex: "email",
      
    },
    {
      title: t("Role"),
      dataIndex: "role",
      
    },

  ];

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  
  const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  };

  useEffect(() => {
    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
        window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
        {
                (loadingStaff || error) ? (
          <div style={{ textAlign: "center", margin: "10em" }}>
            {loadingStaff && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
            {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Error!</strong> {error}
                {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                  Try Again
                </button>*/}
              </div>
            )}
          </div>
        ) : (
             <> 
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="content-page-header ">
                <h5>{t("Users (Staff)")}</h5>
                <div className="list-btn">
                  <ul className="filter-list">
     

                    <li>
                      <a
                        className="btn btn-primary"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#add_user"
                      >
                        <i
                          className="fa fa-plus-circle me-2"
                          aria-hidden="true"
                        />
                        {t("Add User")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
           
            <div className="row">
              <div className="col-sm-12">
              {isMobileDevice() || screenWidth <= 576 ? (
                <>
                  <UserMobile handlePageChange={handlePageChange} currentPage={currentPage} nextPage={nextPage} prevPage={prevPage} count={count} data={data} screenWidth={screenWidth}/>
                </>
              ) : (
                <div className="card-table">
                  <div className="card-body">
                    <div className="table-responsive table-hover">
                      <Table
                        pagination={{
                          total: count,
                          current: currentPage,
                          // showSizeChanger: true,
                          onShowSizeChange: onShowSizeChange,
                          showTotal: (length,range) => showTotal(t,length, range),
                          itemRender:  (page, type, originalElement) => itemRender(t, handlePageChange, currentPage, prevPage, nextPage, page, type, originalElement),
                          
                        }}
                        columns={columns}
                        dataSource={data}
                      />
                    </div>
                  </div>
                </div>
              )}
              </div>
            </div>

          
          </div>
          </>
        )
      }
        </div>

      


        {/* Add User */}
      <AddUser onRefresh={fetchData}/>
      <DeleteUser refreshData={()=>fetchData()} selected_user={selectedUser}/>
        {/* /Add User */}
      </div>
    </>
  );
};

export default Users;
